var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6632_135155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 7.58618H18.6207C19.3825 7.58618 20 8.20372 20 8.96549V18.6207C20 19.3824 19.3825 20 18.6207 20H1.37931C0.617538 20 0 19.3824 0 18.6207V8.96549C0 8.20372 0.617538 7.58618 1.37931 7.58618H17.5862Z",
    fill: "#B0D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5518V18.6207C20 19.3825 19.3825 20 18.6207 20H1.37931C0.617538 20 0 19.3825 0 18.6207V16.5518H20Z",
    fill: "#2FA8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 15.1724C14.19 15.1724 17.5865 11.776 17.5865 7.58621C17.5865 3.39646 14.19 0 10.0003 0C5.81052 0 2.41406 3.39646 2.41406 7.58621C2.41406 11.776 5.81052 15.1724 10.0003 15.1724Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2755 18.6208H4.82725C4.63681 18.6208 4.48242 18.4664 4.48242 18.276C4.48242 18.0855 4.63681 17.9312 4.82725 17.9312H18.2755C18.466 17.9312 18.6204 18.0855 18.6204 18.276C18.6204 18.4664 18.466 18.6208 18.2755 18.6208Z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5515 10.6897H8.44801C7.9719 10.6897 7.58594 11.0757 7.58594 11.5518C7.58594 12.0279 7.9719 12.4138 8.44801 12.4138H11.5515C12.0276 12.4138 12.4135 12.0279 12.4135 11.5518C12.4135 11.0757 12.0276 10.6897 11.5515 10.6897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72373 18.9655C1.53329 18.9655 1.37891 18.8111 1.37891 18.6207V17.931C1.37891 17.7406 1.53329 17.5862 1.72373 17.5862C1.91418 17.5862 2.06856 17.7406 2.06856 17.931V18.6207C2.06856 18.8111 1.91418 18.9655 1.72373 18.9655Z",
    fill: "#B0D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10362 18.9655C2.91317 18.9655 2.75879 18.8111 2.75879 18.6207V17.931C2.75879 17.7406 2.91317 17.5862 3.10362 17.5862C3.29406 17.5862 3.44844 17.7406 3.44844 17.931V18.6207C3.44844 18.8111 3.29406 18.9655 3.10362 18.9655Z",
    fill: "#B0D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4142 18.9655C12.2237 18.9655 12.0693 18.8111 12.0693 18.6207V17.931C12.0693 17.7406 12.2237 17.5862 12.4142 17.5862C12.6046 17.5862 12.759 17.7406 12.759 17.931V18.6207C12.759 18.8111 12.6046 18.9655 12.4142 18.9655Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64167 11.9448L4.63477 12.9517C3.21001 11.53 2.41079 9.59894 2.41407 7.58618H4.48305C4.48265 8.83281 4.90577 10.0426 5.68305 11.0172C5.90755 11.2918 5.88973 11.6913 5.64167 11.9448Z",
    fill: "#65DDB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11063 3.69657C5.16232 4.63473 4.58857 5.88645 4.49684 7.21725C4.48994 7.34139 4.48305 7.46553 4.48305 7.58622H2.41407C2.41079 5.57346 3.21001 3.64242 4.63477 2.2207L6.11063 3.69657Z",
    fill: "#26B99A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.00682e-05V2.06899C9.91408 2.06899 9.82787 2.07243 9.74166 2.07588C8.37139 2.14368 7.07609 2.72183 6.11063 3.69657L4.63477 2.22071C6.05648 0.795949 7.98752 -0.00327192 10.0003 1.00682e-05Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3655 2.22071L13.9 3.68623C12.8661 2.65107 11.4631 2.06929 10 2.06899V1.00682e-05C12.0128 -0.00327192 13.9438 0.795949 15.3655 2.22071Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5866 7.58622H15.5176C15.5173 6.12314 14.9356 4.72017 13.9004 3.68622L15.3659 2.2207C16.7907 3.64242 17.5899 5.57346 17.5866 7.58622Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5862 7.58618C17.5894 9.59894 16.7902 11.53 15.3655 12.9517L14.3586 11.9448C14.1096 11.6935 14.0903 11.2949 14.3137 11.0207C15.093 10.0456 15.5174 8.83441 15.5172 7.58618H17.5862Z",
    fill: "#E64C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 6.98287C10.2977 6.98281 10.1893 6.92415 10.1256 6.82684C10.0619 6.72953 10.0516 6.60669 10.0981 6.50012L12.0981 1.93115C12.1779 1.76277 12.377 1.68822 12.5477 1.76278C12.7185 1.83734 12.7991 2.03405 12.7298 2.20701L10.7298 6.77598C10.675 6.90158 10.551 6.9828 10.414 6.98287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 8.62072C10.5716 8.62072 11.0348 8.15757 11.0348 7.58624C11.0348 7.01491 10.5716 6.55176 10.0003 6.55176C9.42897 6.55176 8.96582 7.01491 8.96582 7.58624C8.96582 8.15757 9.42897 8.62072 10.0003 8.62072Z",
    fill: "#B0D3F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6632_135155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.f73389b3c033d402549985c6a4c33bcc.svg";
export { ForwardRef as ReactComponent };